import type { IconSvgObject } from './types';

const GooglePhotosIcon: IconSvgObject = [
  ["path", { d: "M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2V12Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7 17C7 19.7614 9.23858 22 12 22V12C9.23858 12 7 14.2386 7 17Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12 12C12 14.7614 14.2386 17 17 17C19.7614 17 22 14.7614 22 12L12 12Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M7 7C4.23858 7 2 9.23858 2 12H12C12 9.23858 9.76142 7 7 7Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default GooglePhotosIcon;
